var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPunishment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e47ac3ac-ac71-49e4-bee4-0ebc8d7089b6",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.48,32,75.1,26.8a7.39,7.39,0,0,0-9.75-3.67l-33,15a7.39,7.39,0,0,0-3.66,9.75L53,101.2a7.38,7.38,0,0,0,9.74,3.67L89.43,92.73l7.1-3.3a7.6,7.6,0,0,0,3.09-8.51M54.36,97.07l-1.79-4L86.5,59.17l1.8,4Zm-3.12-6.88-1.8-4L83.38,52.3l1.8,4Zm-3.12-6.88-1.8-4L80.26,45.42l1.79,4ZM45,76.44l-1.8-4L77.13,38.54l1.8,4Zm-3.13-6.88-1.79-4L74,31.66l1.8,4ZM72.37,28l.32.71L38.75,62.68l-1.8-4,33-32.95A4.38,4.38,0,0,1,72.37,28ZM35.63,55.8l-1.8-4L54,31.71l-.07-.08,10.83-4.91ZM31.35,43.27a4.35,4.35,0,0,1,2.27-2.44L46.4,35,32.51,48.93l-1-2.32A4.35,4.35,0,0,1,31.35,43.27ZM55.69,100,89.62,66.05l1.8,4L59,102.46A4.38,4.38,0,0,1,55.69,100Zm40.9-18.6a4.38,4.38,0,0,1-2.17,5.78L83.59,92.08,95.87,79.81ZM75.94,95.56,65.28,100.4,92.75,72.93l1.79,4L75.91,95.53Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPunishment);
export default __webpack_public_path__ + "static/media/punishment.492ff38945e047bbaa27c0e2f630c631.svg";
export { ForwardRef as ReactComponent };